import errors from "../errors";
import validate from "../validate";

type ErrorKeys = keyof typeof errors;

const { SystemError } = errors;

function retrieveCart(): Promise<any> {
    validate.token(sessionStorage.token);

    return fetch(`${process.env.NEXT_PUBLIC_API_URL}/cart`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${sessionStorage.token}`,
            'Content-Type': 'application/json',
        },
    })
        .then(async (res) => {
            if (res.status === 200) {
                return res.json();
            } else if (res.status === 404) {
                return null;
            } else {
                const body = await res.json();
                const { error, message } = body;
                const constructor = errors[error as keyof typeof errors];
                throw new constructor(message);
            }
        })
        .catch(error => {
            throw new SystemError(error.message);
        });
}

export default retrieveCart;


